import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $isCorrect: boolean; $isIncorrect: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.black3};
  border-top: 2px solid ${({ theme }) => theme.colors.black6};
  padding: 12px 24px;
  ${({ $isCorrect }) =>
    $isCorrect &&
    css`
      border-top: 2px solid ${({ theme }) => theme.colors.green6};
    `}
  ${({ $isIncorrect }) =>
    $isIncorrect &&
    css`
      border-top: 2px solid ${({ theme }) => theme.colors.red6};
    `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  max-width: 840px;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: flex-start;
  padding: 12px 0px;
  gap: 12px;

  & > p,
  & > ul {
    margin: 0 !important;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const ExplanationWrapper = styled.div`
  overflow-y: auto;
  max-height: 250px;
`;
